import { useQuery } from '@tanstack/react-query'
import { fetchApi } from '~/api/utils'
import type { PublicShortlist } from '../types'

export const publicShortlistQueryKey = (token: string) => ['shortlists', token]

export const usePublicShortlist = (instance: string, token: string) =>
  useQuery<PublicShortlist>({
    queryKey: publicShortlistQueryKey(token),
    queryFn: ({ signal }) =>
      fetchApi({ url: `/v1/public/shortlists/${token}`, instance, signal }),
    retry: false
  })
